import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'fe-lease',
    templateUrl: './lease.component.html',
    styleUrls: ['./lease.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class LeaseComponent implements OnInit {
    isEnglish = false;
    constructor(private router: Router) {}
    ngOnInit(): void {
        this.isEnglish = this.router.url.startsWith('/en/');
    }
}
